import { ReactNode, CSSProperties } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  dashed?: boolean;
  style?: CSSProperties;
}

export default function EmptyState({
  icon = '⟡',
  title,
  description,
  action,
  dashed = false,
  style,
}: EmptyStateProps) {
  return (
    <div
      className={dashed ? 'acc-empty-state acc-empty-state--dashed' : 'acc-empty-state'}
      style={style}
    >
      <div className="acc-empty-state__icon">{icon}</div>
      <h3 className="acc-empty-state__title">{title}</h3>
      {description && <p className="acc-empty-state__description">{description}</p>}
      {action && <div className="acc-empty-state__action">{action}</div>}
    </div>
  );
}
